module.exports = __webpack_public_path__ + "static/media/USDC-USDT.16c37028.png";